import Vue from 'vue'
import Vuex from 'vuex';
import index from "./modules/index";
import goods from "./modules/goods";

import user from "./modules/user";
import address from "./modules/address";


Vue.use(Vuex);

let store = new Vuex.Store({
  modules: {
    user,
    index,
    goods,
    address
  }
});

export default store;